<template>
  <div class="compliance-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Compliance Report</span>
      </div>

      <data-tables 
          v-loading="loading" 
          :data="tableData" 
          border 
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="uid" label="UID" header-align="center" align="center" width="150"> </el-table-column>
          <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="type" label="Type" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="reason" label="Reason" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="lockDate" label="Lock Date" header-align="center" align="center" width="150"> </el-table-column>
          <el-table-column prop="lockBy" label="Lock By" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="unlockDate" label="Unlock Date" header-align="center" align="center" width="150"> </el-table-column>
          <el-table-column prop="unlockBy" label="Unlock By" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="unlockReason" label="Unlock reason" header-align="center" align="center"> </el-table-column>

        </data-tables>
    </el-card>
  </div>
</template>

<script>
import { getCompliance } from '@/api/bank-account'
export default {  
  props:{
    bankholderID:String
  },
  data(){
    return{
      tableData: [],
      loading: false,
    
    }
  },
  methods:{
    getComplianceData(){
      this.loading = true
      getCompliance(this.bankholderID).then(({result, data}) => {

        this.loading = false
        if(result){
          this.tableData = data
        }
      });
    },
  
  },
  created(){
    this.getComplianceData()
  }
};
</script>

<style>
</style>